import { loaderHtmlString } from "@modules/azm/filter.ts"
import { getShowResultsButton, getShowResultsButtonLocationModal } from "@modules/global/dom.ts"
import { urlEndsWithSpecialLocation } from "@modules/location/special-locations.ts"
import { isMobile } from "@modules/util/device.ts"

export function setShowResultsButton(advertCount: number) {
    if (!isMobile()) {
        return
    }

    const resultsButton = getShowResultsButton()
    const resultsButtonLocation = getShowResultsButtonLocationModal()
    if (resultsButton) resultsButton.innerHTML = `${advertCount === 1 ? "Ein" : advertCount} Treffer anzeigen`
    if (resultsButtonLocation) {
        if (urlEndsWithSpecialLocation(window.location.href)) {
            resultsButtonLocation.innerHTML = "Region wechseln"
        } else {
            resultsButtonLocation.innerHTML = `${advertCount === 1 ? "Ein" : advertCount} Treffer anzeigen`
        }
    }
}

export function setShowResultsButtonLoading() {
    if (!isMobile()) {
        return
    }
    const resultsButton = getShowResultsButton()
    const resultsButtonLocation = getShowResultsButtonLocationModal()
    if (resultsButton) resultsButton.innerHTML = loaderHtmlString()
    if (resultsButtonLocation) resultsButtonLocation.innerHTML = loaderHtmlString()
}
